import React, { useEffect, useState } from 'react'
import "./History.scss";
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';
import axios from "axios";
import { apiUrl } from '../../constants';
import moment from 'moment'
import { Link, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const TYCHistory = (props) => {
    const [data, setdata] = useState([])
    const history = useHistory();

    useEffect(() => {
        getHistory()
    }, [])

    const getsearchcountry = (name) => {
        try {
            var datacountry_get = localStorage.getItem('datacountry3yc')
            var datacountry = JSON.parse(datacountry_get)
            let data = datacountry.find(l => l.name === name)
          return data
        } catch (error) {
          return ""
        }
      }

    const getHistory = () => {
        var allData = []
        var token_get = localStorage.getItem('token')
        var cover_token_get = JSON.parse(token_get)

        var app_version_data_get = localStorage.getItem('app_version')
        var app_version_data = JSON.parse(app_version_data_get)

        var device_type_data_get = localStorage.getItem('device_type')
        var device_type_data = JSON.parse(device_type_data_get)

        axios({
            method: "get",
            url: `${apiUrl}/history?type=3YC&app_version=${app_version_data}&device_type=${device_type_data}`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${cover_token_get}`,
            },
        }).then((res) => {
            res.data.data.map((item, key) => {
                let responsea = JSON.parse(item.param)
                var datachcountry = getsearchcountry(responsea.Calculate3YCRequest.Country)

                var events = {
                    comparison_model: responsea.Calculate3YCRequest.MoDelName,
                    CustomerName: responsea.Calculate3YCRequest.CustomerName,
                    Country: responsea.Calculate3YCRequest.Country,
                    LifetimeWork: responsea.Calculate3YCRequest.LifetimeWork,
                    FuelConsumption: responsea.Calculate3YCRequest.FuelConsumption,
                    DownPayment: responsea.Calculate3YCRequest.DownPayment,
                    FuelPrice: responsea.Calculate3YCRequest.FuelPrice,
                    currency: datachcountry.currency,
                    InterestRate: responsea.Calculate3YCRequest.InterestRate,
                    LeasingTerm: responsea.Calculate3YCRequest.LeasingTerm,
                    MaintenCost: responsea.Calculate3YCRequest.MaintenCost,
                    MoDelName: responsea.Calculate3YCRequest.MoDelName,
                    PriceVat: responsea.Calculate3YCRequest.PriceVat,
                    RepairCost: responsea.Calculate3YCRequest.RepairCost,
                    ResaleValue: responsea.Calculate3YCRequest.ResaleValue,
                };

                allData.push({
                    data: responsea.Calculate3YCResponse,
                    events,
                    id: item.id,
                    comparison_model: responsea.Calculate3YCRequest.MoDelName,
                    currency: datachcountry.currency,
                    createdAt: moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')

                })

            })
            setdata(allData)
        }).catch((err) => {
            if (err.response.status === 401) {
                window.location.href = `callback?is_un_auth=${true}&msg=${err.response.data.message}`
            } else {
                Swal.fire("Error", `${err.response.data.message}`, "error");
            }
        });
    }

    const removeHistory = async (transactionId) => {
        var token_get = localStorage.getItem('token')
        var cover_token_get = JSON.parse(token_get)

        var app_version_data_get = localStorage.getItem('app_version')
        var app_version_data = JSON.parse(app_version_data_get)

        var device_type_data_get = localStorage.getItem('device_type')
        var device_type_data = JSON.parse(device_type_data_get)

        Swal.fire({
            title: "Are you sure?",
            text: "You will delete history !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete history!",
            cancelButtonText: "No, keep it",
        }).then((result) => {
            if (result.value) {
                axios.patch(`${apiUrl}/delete/transaction?transaction_id=${transactionId}&app_version=${app_version_data}&device_type=${device_type_data}`, {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${cover_token_get}`,
                    }
                })
                    .then(async (res) => {
                        Swal.fire("Delete", "Your delete history", "success");
                        getHistory()
                    })
            } 
            // else if (result.dismiss === Swal.DismissReason.cancel) {
            //     Swal.fire("Cancelled", "Your not delete history", "error");
            // }
        });
    }
    return (
        <div className="container">
            {data.length > 0 ?
                data.map((data, key) => {
                    return (
                        <div key={key} className="card">
                            <div className="card-body" style={{
                                background: "#F6F7FB",
                                border: "1px solid #EDF0F7",
                                boxSizing: "border-box",
                                borderRadius: "6px",
                                alignItems: "center"
                            }}>

                                <div className="d-flex justify-content-between"
                                    style={{
                                        alignItems: "center"
                                    }}
                                >
                                    <div>
                                        <p style={{
                                            fontStyle: "normal",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                            lineHeight: "21px",
                                            color: "#000000"
                                        }}
                                        >
                                            {data.events.CustomerName}
                                        </p>
                                        <p style={{
                                            marginTop: "-15px",
                                            fontStyle: "normal",
                                            fontWeight: "normal",
                                            fontSize: "12px",
                                            lineHeight: "14px",
                                            color: "#B1B4C1"
                                        }}>
                                            {data.createdAt}

                                        </p>
                                    </div>

                                    <div style={{ marginTop: "-20px" }}
                                        onClick={() => {
                                            var token_get = localStorage.getItem('token')
                                            var cover_token_get = JSON.parse(token_get)
                                            history.push(`/View3YC?login_token=${cover_token_get}`, data);
                                        }}
                                    >

                                        <a style={{ color: "#4A4F6D", fontSize: "16px", textAlign: "right", marginRight: "5px" }}>
                                            View
                            </a>
                                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#4A4F6D" />
                                        </svg>

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col"
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "normal",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#6D749E"
                                        }}
                                    >
                                        Lifetime working:
                        </div>
                                    <div className="col"
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#000000"
                                        }}
                                    >
                                        {data.events.LifetimeWork}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col"
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "normal",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#6D749E"
                                        }}
                                    >
                                        Leasing terms:
                        </div>
                                    <div className="col"
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#000000"
                                        }}
                                    >
                                        {data.events.LeasingTerm}

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col"
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "normal",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#6D749E"
                                        }}
                                    >
                                        Price:
                        </div>
                                    <div className="col"
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#000000"
                                        }}
                                    >
                                        {data.data.Price} {data.currency}
                                    </div>
                                </div>
                                <hr />
                                <div className="d-flex justify-content-between" style={{ alignItems: "center" }}>
                                    <a
                                        style={{
                                            borderRadius: "6px",
                                            background: "#3A75F6",
                                            color: "#fff",
                                            paddingRight: "10px",
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                            paddingBottom: "10px",
                                            alignItems: "center"
                                        }}
                                    >
                                        {data.events.comparison_model}
                                    </a>

                                    <a style={{ color: "red", textAlign: "right" }}>
                                        <FontAwesomeIcon icon={faTrash} size="1x"
                                            onClick={() => {
                                                removeHistory(data.id)
                                            }} />
                                    </a>
                                </div>

                            </div>
                        </div>
                    )
                })

                : null}
            <div className="container" style={{ marginTop: "60px" }}>
            </div>
        </div>

    )
}

export default TYCHistory
